import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, RefreshCw, X } from 'lucide-react';
import { Button } from '../ui/Button';

interface AgentLoopErrorProps {
  error: string;
  onRetry?: () => void;
  onDismiss: () => void;
}

export function AgentLoopError({ error, onRetry, onDismiss }: AgentLoopErrorProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      className="bg-danger-500/10 border border-danger-500/50 rounded-lg p-4"
    >
      <div className="flex items-start gap-3">
        <XCircle className="w-5 h-5 text-danger-500 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-danger-400 mb-1">
            Agent Error
          </h4>
          <p className="text-sm text-text-secondary break-words">
            {error}
          </p>
        </div>
        <button
          onClick={onDismiss}
          className="text-text-muted hover:text-text-primary transition-colors flex-shrink-0"
          aria-label="Dismiss error"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      {onRetry && (
        <div className="mt-3 flex gap-2">
          <Button
            variant="danger"
            size="sm"
            leftIcon={<RefreshCw className="w-4 h-4" />}
            onClick={onRetry}
          >
            Edit & Retry
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onDismiss}
          >
            Dismiss
          </Button>
        </div>
      )}
    </motion.div>
  );
}
